import React, { useState, useEffect } from "react";
import { callAPI, useStore, usePage, useUser } from "../../../Utils/utils";
import { scrollToTop } from "../../Global/Scroll";
import { useNavigate, useParams } from "react-router-dom";
// import { page_labels } from "../../../Constants/Labels";
import { select_store_message, home_page_message } from "../../../Constants/Messages"
import Alert from "../../Alert/Alert";
import Layout from "../../Global/Layout";
import Button from "../../Global/Button";
import BreadCrumb from "../../Global/BreadCrumb/BreadCrumb";
import TextEditor from "../../Global/TextEditor/TextEditor"


const PrivacyPolicy = () => {
    const { id } = useParams()
    const { user, setUser } = useUser();
    const { store, setStore } = useStore();
    const [content, setContent] = useState({});
    const [title, setTitle] = useState('');
    const [alert, setAlert] = useState()
    const [loading, setLoading] = useState(false);
    const [storeName, setStoreName] = useState([]);
    const [block,setBlock]=useState({})

    const navigate = useNavigate();

    useEffect(() => {
        if (store?.id) {
            var pay_load = {
                "store_id": store?.id,
                "page_id": id
            }

            callAPI("/admin/settings/pages/get",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': user?.auth_token
                    },
                    body: JSON.stringify(pay_load)
                }, navigate, setLoading, setStore)
                .then(data => {
                    // console.log("api response " + JSON.stringify(data))
                    if (data.success) {
                        setTitle(data.record?.config?.blocks[0]?.content?.title)
                        setContent(data.record?.config?.blocks[0]?.content?.content)
                        setBlock(data.record?.config?.blocks[0]?.content)
                    } else {
                        // console.log("data.errors", data.errors)
                    }
                }
                )
        }
    }, [])


    useEffect(() => {
        if (storeName?.length == 0 || storeName == undefined) {
            setStoreName(() => [store?.name])
        }
        else {
            setStoreName((existingStoreId) => [...existingStoreId, store?.name])
        }
    }, [store?.id])

    useEffect(() => {
        if (storeName[1] != undefined) {
            if (storeName[0] != storeName[1]) {
                navigate("/admin")
                setStoreName([])
            }
        }
    }, [storeName])



    const onSave = () => {

        scrollToTop()

        var pay_load = {
            "page_id": id,
            "store_id": parseInt(store?.id),
            "config": {
                "blocks": [
                    {
                        "label": "PRIVACY POLICY",
                        "name": "privacy_policy",
                        "content": {
                            "title": title,
                            "content": content,
                        }
                    }
                ]
            }
        }

        console.log("pay_load", pay_load)
        callAPI("/admin/settings/pages/save",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': user?.auth_token
                },
                body: JSON.stringify(pay_load)
            }, navigate, setLoading, setStore)
            .then(data => {
                if (data.success) {
                    setAlert({ text: "Page saved successfully", type: "success" })
                } else {
                    // console.log("data.errors", data.errors)
                    setAlert({ text: "Error in page saving", type: "error" })
                }
            })
    }

    let select_store = store?.id == null || store?.id == undefined || store?.id == 0 || store?.name == "Global Admin" ? true : false

    // console.log("config", config);

    return (
        <Layout>
            <div className="breadcrumb-wrapper breadcrumb-contacts">
                <BreadCrumb />
                {!select_store && <Button className={'btn btn-primary'} value={"Save"} onClick={() => onSave()} />}
            </div>

            {alert?.text ?
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
                : ''}

            {select_store ?
                <div className="card card-default">
                    <div className={`card-body select_store`}>
                        <p className="text-center">{select_store_message?.select_store}</p>
                    </div>
                </div>
                :
                <>
                    <div className="col-lg-10">
                        <div className="card card-default">
                            <div className="card-header card-header-border-bottom">
                                <h2>Privacy Policy</h2>
                            </div>

                            <div className="card-body">
                                {/* <h5 className="mb-3">FAQ</h5> */}
                                <div className="col-lg-10">
                                    <div className="form-group ">
                                        <label className="form-label">Title</label>
                                        <input type="text" className="form-control" name='title' value={title} onChange={(event)=>setTitle(event.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-10">
                                    <div className="form-group page_content">
                                        <label className="form-label">Content</label>
                                        <div className="describtion" >
                                            <TextEditor onChangeTextEditorValue={setContent} productDescription={block.content || ""} />
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </Layout>
    )
}

export default PrivacyPolicy